import "assets/scss/layouts/patient.scss";

import React from "react";
import { useApp } from "context";
import { Enums, Helpers } from "utils";
import { Common } from "components";
import { Outlet } from "react-router-dom";
import { Slide, Snackbar } from "@mui/material";

export const PatientLayout = () => {
  const { theme, feedback, setFeedback } = useApp();

  const transitionUp = (props: any) => <Slide {...props} direction="up" />;

  const shouldShowSnackbar = () =>
    Helpers.hasValue(feedback?.message) &&
    feedback?.severity === Enums.EnumFeedback.Success;

  const handleSnackbarClose = () => setFeedback(null);

  return (
    <div
      className="qh-patient"
      style={{
        color: theme.palette.font.color,
        backgroundColor: theme.palette.background.color,
      }}
    >
      <div className="qh-container">
        <Common.Navigation />
        <div className="qh-wrapper">
          <Outlet />
        </div>
        <Snackbar
          open={shouldShowSnackbar()}
          onClose={handleSnackbarClose}
          message={feedback?.message}
          autoHideDuration={4000}
          key={"snackbar-feedback"}
          TransitionComponent={transitionUp}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        />
      </div>
    </div>
  );
};
